import React from 'react';
import { Link } from 'react-router-dom';
import './productpresentation.css';
import { FaArrowRight } from 'react-icons/fa';
import productCategories from './productCategories';
import homeContent from '../../../content/pages/home.json';

const ProductPresentation = () => {
    const { heading, description, linkText } = homeContent.productPresentation;

    return (
        <section className="home-product-presentation">
            <div className="home-product-presentation-text">
                <h1>{heading}</h1>
                <p>
                    {description.split('\n\n').map((paragraph, i) => (
                        <React.Fragment key={i}>
                            {i > 0 && <><br /><br /></>}
                            {paragraph}
                        </React.Fragment>
                    ))}
                </p>
                <Link to="/produkter" className="product-link-home">
                    {linkText} <FaArrowRight />
                </Link>
            </div>
            <div className="home-product-grid">
                {productCategories.map((product, index) => (
                    <div className="home-product-card" key={index}>
                        <img src={product.image} alt={product.category} />
                        <h3>{product.category}</h3>
                        <p>{product.description}</p>
                        <Link
                            to={`/produkter/${product.category === 'Övrigt' ? 'ovrigt' : product.category.toLowerCase()}`}
                            className="home-product-link"
                        >
                            Läs mer
                        </Link>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ProductPresentation;
